import update from 'immutability-helper';
import moment from 'moment-timezone';
import * as types from './types';

const initialState = {
  interval: {
    from: moment().format(),
    to: moment().format(),
    shortcut: 'custom',
  },
  currentErrorCode: '',
  errorCodeSelected: [],
  metric: '',
  code: '',
  filter: [],
};

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SET_INTERVAL] = (state, action) => update(state, {
  interval: {
    $set: {
      from: action.from,
      to: action.to,
      shortcut: action.shortcut || 'custom',
    },
  },
});

switchMap[types.SET_METRIC] = (state, action) => update(state, {
  metric: {
    $set: action.metric,
  },
});

switchMap[types.SET_CODE] = (state, action) => update(state, {
  code: {
    $set: action.code,
  },
});

switchMap[types.SET_FILTER] = (state, action) => update(state, {
  filter: {
    $set: action.filter,
  },
});

switchMap[types.SET_CURRENT_ERROR_CODE] = (state, action) => update(state, {
  currentErrorCode: {
    $set: action.currentErrorCode,
  },
});

switchMap[types.SET_ERROR_CODE_SELECTED] = (state, action) => update(state, {
  errorCodeSelected: {
    $set: action.errorCodeSelected,
  },
});

switchMap[types.ADD_ERROR_CODE] = (state, action) => update(state, {
  errorCodeSelected: {
    $push: [action.code],
  },
});

switchMap[types.REMOVE_ERROR_CODE] = (state, action) => update(state, {
  errorCodeSelected: {
    $splice: [[action.index, 1]],
  },
});

switchMap[types.SET_BASE_STATE] = (state, action) => update(state, {
  $merge: action.state,
});

export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
